import gql from "graphql-tag";

const VitalProps = gql`
    fragment VitalProps on Vital {
        id
        score
        initial
        care
        created_at
        frequency
        questions {
            answer
            question
            value
        }
        author {
            id
            image
            first_name
            surname
            middle_name
            type {
                id
                name
            }
            designation {
                id
                name
            }
            email
        }
    }
`;

const LIST = gql`
    query GetVitals($id: ID!) {
        GetPatientVitals(admission: $id) {
            docs {
                ...VitalProps
            }
        }
    }
    ${VitalProps}
`;

const CREATE = gql`
    mutation RecordNewVital($model: VitalInput!) {
        RecordNewVital(model: $model) {
            message
            doc {
                ...VitalProps
            }
        }
    }
    ${VitalProps}
`;
export { CREATE, LIST };
